export const UPDATE_BAG_PARAM = {
    REQUEST: 'BAG.INLINE_EDIT_BAG_PARAM.UPDATE_BAG_PARAM.REQUEST',
    SUCCESS: 'BAG.INLINE_EDIT_BAG_PARAM.UPDATE_BAG_PARAM.SUCCESS',
    FAILED: 'BAG.INLINE_EDIT_BAG_PARAM.UPDATE_BAG_PARAM.FAILED',
};

export const RESET_ERROR = 'BAG.INLINE_EDIT_BAG_PARAM.RESET_ERROR';

export const CLEAR_STATE = 'BAG.INLINE_EDIT_BAG_PARAM.CLEAR_STATE';
